export const REDIRECT_COUNT_DOWN_TIME = 5
